








import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import data from "./countries.json"

// code == -1 for other

interface ICountry {
  ja: string,
  en: string,
  code: number,
}

@Component
export default class extends Vue {
  @Prop({ required: true })
  value!: number | null

  code: number | null = this.value

  @Prop({ required: true })
  locale!: string

  get options() {
    const locale = this.locale
    const countries = Object.values(data)
    countries.splice(countries.findIndex((c) => c.code === 392), 1)
    // @ts-ignore
    countries.sort((a, b) => a[locale] < b[locale] ? -1 : 1)
    return countries
  }

  @Watch('code')
  onCoddChange() {
    this.$emit('input', this.code)
  }
}
